import SectionLabel from "@/components/base/SectionLabel";
import { companyData } from "@/mocks/aboutData";

export default function CompanySection() {
  return (
    <section id="company" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="reveal max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <SectionLabel label={companyData.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900">
            {companyData.heading}
          </h2>
        </div>

        <div className="reveal max-w-2xl mx-auto">
          <div className="bg-background-100 border border-background-200/70 rounded-lg overflow-hidden">
            <table className="w-full">
              <tbody>
                {companyData.rows.map((row, idx) => (
                  <tr
                    key={idx}
                    className={idx < companyData.rows.length - 1 ? "border-b border-background-200/50" : ""}
                  >
                    <th className="w-[120px] md:w-[140px] px-4 md:px-6 py-3.5 md:py-4 text-left text-xs md:text-sm font-medium text-foreground-600 bg-background-100 whitespace-nowrap">
                      {row.th}
                    </th>
                    <td className="px-4 md:px-6 py-3.5 md:py-4 text-sm md:text-base text-foreground-800 leading-relaxed bg-background-50/60">
                      {row.td}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-7 md:mt-9 text-center">
            <a
              href={companyData.linkHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-5 py-3 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              {companyData.linkLabel}
              <i className="ri-external-link-line text-xs" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}